import Agent from "./agent.jsx";

export const getBarberUnavailabilities = async (barber) => {
  // Your API call to authenticate the user
  // If successful, save the token to localStorage
  const { requests } = Agent();
  return await requests.get(`/BarberUnavailability/${barber}`, null, null);
};
